import { HighlightItemData, SeriesItemIdentifier } from '@mui/x-charts-pro';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ChartsHighlightContextType {
  highlightedItem: HighlightItemData | null;
  setHighlightedItem: (item: HighlightItemData) => void;
  isHighlighted: (id: SeriesItemIdentifier['seriesId']) => boolean;
  isFaded: (id: SeriesItemIdentifier['seriesId']) => boolean;
}

const ChartsHighlightContext = createContext<
  ChartsHighlightContextType | undefined
>(undefined);

export const ChartsHighlightProvider = ({
  value,
  children,
}: {
  value: ChartsHighlightContextType;
  children: ReactNode;
}) => {
  return (
    <ChartsHighlightContext.Provider value={value}>
      {children}
    </ChartsHighlightContext.Provider>
  );
};

export const useChartsHighlight = () => {
  const [highlightedItem, setHighlightedItem] =
    useState<HighlightItemData | null>(null);

  const isHighlighted = (id: string) => highlightedItem?.seriesId === id;
  const isFaded = (id: string) =>
    highlightedItem ? highlightedItem?.seriesId !== id : false;

  return { highlightedItem, setHighlightedItem, isHighlighted, isFaded };
};

export const useChartsHighlightContext = () => {
  const context = useContext(ChartsHighlightContext);
  if (!context) {
    throw new Error(
      'useChartsHighlight must be used within a ChartsHighlightProvider',
    );
  }
  return context;
};
